import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'

const serverUrl = import.meta.env.VITE_SERVER_URL ?? '' //'https://manholes.pestec.com'

const uri = import.meta.env.VITE_GRAPHQL_LOGIN_URL ?? serverUrl + '/graphql/authorization/login'

export const apolloClient = new ApolloClient({
  link: new HttpLink({
    uri,
    credentials: 'include',
  }),
  cache: new InMemoryCache(),
  defaultOptions: {
    mutate: {
      errorPolicy: 'all',
    },
  },
})
